/** Parse Birdsview / Shopware customer JSON `{ id: string | null }`. */
export function parseCustomerIdJson(body: unknown): string | null {
  if (body == null || typeof body !== 'object') {
    return null;
  }
  const id = (body as { id?: unknown }).id;
  if (typeof id === 'string') {
    return id;
  }

  return null;
}
